module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='telegauge@4.9.0 - Built on Wed Jul 05 2023 10:09:15 GMT-0400 (Eastern Daylight Time)';
}
return __p;
};
